import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";
import FormData from "form-data";
import axios from "axios";

function Binary() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    account_no: "",
    holdername: "",
    ifsc_code: "",
  });
  const [Isdigital, setIsdigital] = useState(false);

  const [img, setImg] = useState();
  const [previewImg, setPreviewImg] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // console.log("ththth", cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      setImg("b " + base64String);
      setPreviewImg(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      account_no: "",
      holdername: "",
      ifsc_code: "",
      status: "",
      document_type: "",
    });
    const apiUrl = "https://ubr8htfrxj.execute-api.ap-south-1.amazonaws.com/default/ainxt_signature-validation_service?IsSdk=0";
    const isDigitalQueryParam = Isdigital ? "Isdigital=1" : "Isdigital=0";
    const urlWithQueryParam = `${apiUrl}?${isDigitalQueryParam}`;
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: urlWithQueryParam,
      headers: {
        "x-api-key": "KFMHLbn1ph7rJUmoQaUCu3MybLXVvGP28els57p9",
        "authorizationToken": "vH24IILXH3wR4kRY",
        // "client-secret-key" : "8RNz7liAIlj26BooC5M3avqKjAX56ZZ2"
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        setCardData(response.data);
        console.log(response.data)
        setLoading(true);
      })
      .catch(function (error) {
        setLoading(true);
        alert("Something went wrong with the server");
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div className="container containerBoreder" id="pan">
        <h2 className="pageTitle">Sign Crop</h2>
        <div className="row">
          <div className="col-4">
            <input type="file" onChange={onChange} />
            <label>
            Is Digital:
            <input
              type="checkbox"
              checked={Isdigital}
              onChange={() => setIsdigital(!Isdigital)}
            />
          </label>
            {loading ? (
              <button className="btn btn-primary mt-3" onClick={submit}>
                Submit
              </button>
            ) : (
              <ReactBootStrap.Spinner animation="border" />
            )}

            {previewImg && (
              
              <img
                src={previewImg}
                alt="Preview"
                style={{ width: "100%", marginTop: "10px" }}
              />
            )}
          </div>
          <div className="col-8">
            
  {previewImg && (
    <div style={{ width: "400px", marginTop: "40px" }}>
      {cardData.cropped_sign && (
        
        <div style={{ overflow: "hidden" }}>
          <img
            style={{
              width: "100%",
              objectFit: "contain",
            }}
            
            src={`data:image/png;base64,${cardData.cropped_sign}`}
            alt="Cropped Sign"
            onLoad={(e) => {
              const { target } = e;
              const container = target.parentNode;
              const aspectRatio = target.naturalWidth / target.naturalHeight;
              const containerWidth = container.offsetWidth;
              const containerHeight = containerWidth / aspectRatio;
              container.style.height = `${containerHeight}px`;
            }}
          />
        </div>
      )}
      <br/>
      {cardData.cropped_sign && ( <h6>Original Cropped</h6>)}
      {cardData.original_cropped && (
        <div style={{ overflow: "hidden" }}>
          <img
            style={{
              width: "100%",
              objectFit: "contain",
            }}
            src={`data:image/png;base64,${cardData.original_cropped}`}
            alt="Original Cropped"
            onLoad={(e) => {
              const { target } = e;
              const container = target.parentNode;
              const aspectRatio = target.naturalWidth / target.naturalHeight;
              const containerWidth = container.offsetWidth;
              const containerHeight = containerWidth / aspectRatio;
              container.style.height = `${containerHeight}px`;
            }}
          />
        </div>
      )}
    </div>
  )}
</div>

        </div>
        <br />
        <div className="row">
         
          <div className="col-8">
            {cardData.cropped_sign && (
              <div>
                <a
                  href={`data:image/png;base64,${cardData.cropped_sign}`}
                  download="cropped_sign.png"
                  className="btn btn-primary mt-3"
                >
                  Download Cropped Sign
                </a>
              </div>
            )}
          </div>
        </div>
        <br />
        {cardData.status && (
          <table className="table">
            <tbody>
              <tr>
                <th>Status</th>
                <td>{cardData.status}</td>
              </tr>
              <tr>
                <th>Crop Status</th>
                <td>{cardData.cropped_status}</td>
              </tr>
              <tr>
                <th>Remark</th>
                <td>{cardData.remark}</td>
              </tr>
              <tr>
                <th>Sign Label</th>
                <td>{cardData.sign_label}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
  
  
  
}

export default Binary;
